import Raffle from '../models/Raffle';
import { FETCHED_RAFFLE, FETCHING_RAFFLE, CLEAR_FETCHED_RAFFLE } from '../actions/RaffleDetailActions';

const initialState = {
	raffle: null,
	raffleNotFound: false,
	fetching: false
};

export default class RaffleDetailReducer {

	/**
	 * @param {object} state
	 * @param {object} action
	 */
	static reduce(state = initialState, action) {
		switch (action.type) {
			case FETCHING_RAFFLE:
				return {
					...state,
					fetching: true
				};
			case FETCHED_RAFFLE:
				return RaffleDetailReducer.normalize({
					...state,
					raffle: action.raffle,
					raffleNotFound: action.raffle === null,
					fetching: false
				});
			case CLEAR_FETCHED_RAFFLE:
				return {
					...state,
					raffle: null,
					raffleNotFound: false,
					fetchingRaffle: false
				};
			default:
				return state;
		}
	}

	/**
	 * @param {object} state
	 * @return {*}
	 */
	static normalize = (state) => ({
		...state,
		raffle: state.raffle === null ? null : Raffle.normalize(state.raffle)
	});
}



// WEBPACK FOOTER //
// ./reducers/RaffleDetailReducer.js